import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";

import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import StatsStrip from "@/components/sections/StatsStrip";
import About from "@/components/sections/About";
import Verticals from "@/components/sections/Verticals";
import Footprint from "@/components/sections/Footprint";
import Leadership from "@/components/sections/Leadership";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const tick = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-white text-[--kdm-ink]" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <StatsStrip />
        <About />
        <Verticals />
        <Footprint />
        <Leadership />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
